import Icon from 'components/icon/icon';

export default Icon;
